const jayap = {
  name: 'Jayap',
  type: 1,
  dmgMod: 0,
  speed: 0.917,
  img: 'jayap'
}

const korb = {
  name: 'Korb',
  type: 0,
  dmgMod: 28,
  speed: 0.783,
  img: 'korb'
}

const kroostra = {
  name: 'Kroostra',
  type: 1,
  dmgMod: 14,
  speed: 0.850,
  img: 'kroostra'
}

const kwath = {
  name: 'Kwath',
  type: 0,
  dmgMod: 14,
  speed: 0.850,
  img: 'kwath'
}

const laka = {
  name: 'Laka',
  type: 0,
  dmgMod: 0,
  speed: 0.917,
  img: 'laka'
}

const peye = {
  name: 'Peye',
  type: 0,
  dmgMod: -4,
  speed: 1,
  img: 'peye'
}

const seekalla = {
  name: 'Seekalla',
  type: 1,
  dmgMod: -4,
  speed: 1,
  img: 'seekalla'
}

const shtung = {
  name: 'Shtung',
  type: 1,
  dmgMod: 28,
  speed: 0.783,
  img: 'shtung'
}

const plagueAkwin = {
  name: 'Plague Akwin',
  type: 0,
  dmgMod: -2,
  speed: 0.950,
  img: 'plague-akwin'
}

const plagueBokwin = {
  name: 'Plague Bokwin',
  type: 1,
  dmgMod: 7,
  speed: 0.883,
  img: 'plague-bokwin'
}

const grips = [jayap, korb, kroostra, kwath, laka, peye, seekalla, shtung, plagueAkwin, plagueBokwin]

export default grips
